
/**
 * Adds resource hints to the document head to optimize loading
 */
export const addResourceHints = () => {
  // Preconnect to critical origins
  const preconnectOrigins = [
    'https://fonts.googleapis.com',
    'https://fonts.gstatic.com',
    'https://lovable-uploads.s3.amazonaws.com'
  ];
  
  preconnectOrigins.forEach(origin => {
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = origin;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
  });
  
  // Preload critical images - ensure the paths are correct
  const criticalImages = [
    '/lovable-uploads/ac7da958-8971-47d6-8588-0611fa790b37.png', // Hero image
    '/lovable-uploads/5e47819f-d6f6-4c55-a191-8c73e8dc095c.png'
  ];
  
  // Check if preload links already exist
  const existingPreloads = Array.from(document.querySelectorAll('link[rel="preload"][as="image"]'))
    .map(link => link.getAttribute('href'));
  
  criticalImages.forEach((imagePath, index) => {
    // Don't add duplicate preload links
    if (existingPreloads.includes(imagePath)) {
      return;
    }
    
    const link = document.createElement('link');
    link.rel = 'preload';
    link.as = 'image';
    link.href = imagePath;
    // Set highest priority for hero image
    if (index === 0 || imagePath.includes('ac7da958-8971-47d6-8588-0611fa790b37')) {
      link.setAttribute('fetchpriority', 'high');
    }
    document.head.appendChild(link);
  });
  
  // Debug - log image paths to confirm they're correct
  console.log('Critical images preloaded:', criticalImages);
};

/**
 * Optimizes images on the page by converting them to WebP format where possible
 */
export const optimizeImages = () => {
  // Find all images and check if they can be converted to WebP
  const images = document.querySelectorAll('img');
  
  images.forEach(img => {
    const src = img.getAttribute('src');
    if (src && !src.endsWith('.webp') && !src.endsWith('.svg')) {
      // Hero image should always be prioritized
      if (src.includes('ac7da958-8971-47d6-8588-0611fa790b37')) {
        img.setAttribute('decoding', 'sync');
        img.setAttribute('fetchpriority', 'high');
        img.setAttribute('loading', 'eager');
        // Force display
        img.style.opacity = '1';
        img.style.visibility = 'visible';
        console.log('Hero image found and prioritized:', src);
      } else {
        // Set decoding to async for non-critical images
        img.setAttribute('decoding', 'async');
        
        // Add fetchpriority if it's in the viewport
        if (isInViewport(img)) {
          img.setAttribute('fetchpriority', 'high');
        } else {
          img.setAttribute('loading', 'lazy');
        }
      }
    }
  });
};

/**
 * Checks if an element is in the viewport
 */
const isInViewport = (element: Element) => {
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
};

export default {
  addResourceHints,
  optimizeImages
};
